/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Step_4Inputs */

const en_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earn your rewards`)
};

const ar_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على مكافآتك`)
};

const de_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdiene deine Belohnungen`)
};

const es_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gana tus recompensas`)
};

const fr_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagnez vos récompenses`)
};

const it_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni le tue ricompense`)
};

const ja_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報酬を獲得する`)
};

const ko_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보상 받기`)
};

const pt_br_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhe suas recompensas`)
};

const ru_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте свои награды`)
};

const th_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับรางวัลของคุณ`)
};

const tr_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödüllerini kazan`)
};

const zh_cn_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获得奖励`)
};

const zh_tw_invite_page_step_4 = /** @type {(inputs: Invite_Page_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲得獎勵`)
};

/**
* | output |
* | --- |
* | "Earn your rewards" |
*
* @param {Invite_Page_Step_4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_step_4 = /** @type {((inputs?: Invite_Page_Step_4Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Step_4Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_step_4(inputs)
	if (locale === "ar") return ar_invite_page_step_4(inputs)
	if (locale === "de") return de_invite_page_step_4(inputs)
	if (locale === "es") return es_invite_page_step_4(inputs)
	if (locale === "fr") return fr_invite_page_step_4(inputs)
	if (locale === "it") return it_invite_page_step_4(inputs)
	if (locale === "ja") return ja_invite_page_step_4(inputs)
	if (locale === "ko") return ko_invite_page_step_4(inputs)
	if (locale === "pt_br") return pt_br_invite_page_step_4(inputs)
	if (locale === "ru") return ru_invite_page_step_4(inputs)
	if (locale === "th") return th_invite_page_step_4(inputs)
	if (locale === "tr") return tr_invite_page_step_4(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_step_4(inputs)
	return zh_tw_invite_page_step_4(inputs)
});